export interface HandoverPreferenceOption {
  value: string;
  labelKey: string;
}

export const HANDOVER_PREFERENCE_OPTIONS: HandoverPreferenceOption[] = [
  { value: 'Compliance Risk', labelKey: 'compliance' },
  { value: 'Incident', labelKey: 'incidents' },
  { value: 'Equipment Risk', labelKey: 'equipment' },
  { value: 'Health and Safety Risk', labelKey: 'healthAndSafety' },
  { value: 'Inventory Risk', labelKey: 'inventory' },
  { value: 'Operational Risk', labelKey: 'operations' },
  { value: 'Supply Chain Risk', labelKey: 'supplyChain' },
];
